/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Actions from './Actions/index'
import Content from './Content/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content",
  height = "auto",
  onUploadCaptures
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Vertical}`}
>
<Content
  viewPath={`${viewPath}/Content`}
 onUploadCaptures={onUploadCaptures}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
{children}
</React.Fragment>)
}